import { createBaseComponent } from './createBaseComponent.js';
import createAtomicPluginToolbar from './toolbars/createAtomicPluginToolbar.js';
import createInlinePluginToolbar from './toolbars/createInlinePluginToolbar.js';
import { createBaseInsertPluginButton } from './createBaseInsertPluginButton.js';
import { generateInsertPluginButtonProps } from '../Utils/generateInsertPluginButtonProps.js';
import { getToolbarTheme, TOOLBARS, setBlockNewEntityData, deleteBlock } from 'wix-rich-content-editor-common';
import { simplePubsub, WRAP, NO_WRAP } from 'wix-rich-content-common';
import { UNSUPPORTED_BLOCKS_TYPE } from '../consts.js';
import 'react';
import 'prop-types';
import 'lodash';
import 'classnames';
import '../style-inject.es-746bb8ed.js';
import 'react-dom';
import './baseToolbarButton.js';
import 'wix-rich-content-ui-components';
import './buttons/keys.js';
import './buttons/index.js';
import './buttons/createBlockButton.js';
import './buttons/createBlockAlignmentButton.js';
import './buttons/createBlockAlignmentAndSizeButton.js';
import './buttons/createBlockSizeButton.js';
import './buttons/createSliderPanelButton.js';
import './buttons/BlockLinkButton.js';
import './buttons/BlockSpoilerButton.js';
import '../Icons/SpoilerButtonIcon.js';
import '../Icons/SizeSmallIcon.js';
import '../Icons/SizeMediumIcon.js';
import '../Icons/SizeLargeIcon.js';
import '../Icons/SizeOriginalIcon.js';
import '../Icons/AlignCenterIcon.js';
import '../Icons/SizeSmallCenterIcon.js';
import '../Icons/SizeSmallLeftIcon.js';
import '../Icons/SizeSmallRightIcon.js';
import '../Icons/SizeBestFitIcon.js';
import '../Icons/SizeFullWidthIcon.js';
import '../Icons/TrashIcon.js';
import '../Icons/WidthIcon.js';
import '../Icons/HeightIcon.js';
import '../ToolbarContent-5f9b4523.js';
import 'react-measure';
import './toolbars/toolbarUtils.js';
import './default-toolbar-settings.js';
import '../Utils/getPluginParams.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getData = (contentBlock, { getEditorState }, removeConfigFromData) => () => {
  const _a = getEditorState().getCurrentContent().getEntity(contentBlock.getEntityAt(0)).getData(), { config } = _a, rest = __objRest(_a, ["config"]);
  return removeConfigFromData ? __spreadValues({}, rest) : __spreadValues({ config }, rest);
};
const setData = (contentBlock, { getEditorState, setEditorState }, type) => (newData) => {
  const editorState = setBlockNewEntityData(
    getEditorState(),
    contentBlock.getKey(),
    newData,
    type
  );
  setEditorState(editorState);
};
const deleteEntity = (contentBlock, { getEditorState, setEditorState }) => () => setEditorState(deleteBlock(getEditorState(), contentBlock.getKey()));
const DEFAULT_SETTINGS = {
  showInsertButtons: true
};
const createBasePlugin = (config, underlyingPlugin) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const pubsub = simplePubsub();
  const settings = __spreadValues(__spreadValues({}, DEFAULT_SETTINGS), config.settings);
  const helpers = config.helpers || {};
  const isMobile = config.isMobile || false;
  const {
    t,
    anchorTarget,
    relValue,
    customStyleFn,
    getEditorBounds,
    onOverlayClick,
    disableRightClick,
    commonPubsub,
    defaultPluginData,
    pluginDefaults,
    onComponentMount,
    locale,
    theme,
    shouldRenderOptimizedImages,
    iframeSandboxDomain,
    setInPluginEditingMode,
    getInPluginEditingMode,
    getEditorState,
    renderInnerRCE,
    decoratorTrigger,
    noPluginBorder,
    noPointerEventsOnFocus,
    withHorizontalScroll,
    innerRCERenderedIn,
    disableKeyboardEvents,
    textWrap: textWrapBoolean
  } = config;
  const textWrap = textWrapBoolean ? WRAP : NO_WRAP;
  const ensureTextWrap = (config2) => config2 && !(config2 == null ? void 0 : config2.textWrap) ? __spreadProps(__spreadValues({}, config2), { textWrap }) : config2;
  defaultPluginData && (pluginDefaults[config.type] = __spreadProps(__spreadValues({}, defaultPluginData), {
    config: ensureTextWrap(defaultPluginData.config)
  }));
  const insertButtons = (_b = (_a = config == null ? void 0 : config.toolbar) == null ? void 0 : _a.InsertButtons) == null ? void 0 : _b.map((button) => {
    var _a2;
    return __spreadProps(__spreadValues({}, button), {
      componentData: __spreadProps(__spreadValues({}, button == null ? void 0 : button.componentData), {
        config: ensureTextWrap((_a2 = button == null ? void 0 : button.componentData) == null ? void 0 : _a2.config)
      })
    });
  });
  const toolbarTheme = __spreadValues(__spreadValues({}, getToolbarTheme(config.theme, "plugin")), config.theme);
  const InlinePluginToolbar = ((_c = config.toolbar) == null ? void 0 : _c.InlinePluginToolbarButtons) && createInlinePluginToolbar({
    buttons: {
      all: config.toolbar.InlinePluginToolbarButtons,
      hidden: ((_d = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _d.hidden) || []
    },
    theme: __spreadValues(__spreadValues({}, toolbarTheme), config.theme),
    commonPubsub,
    isMobile,
    t,
    name: config.toolbar.name,
    getToolbarSettings: config.getToolbarSettings
  });
  const Toolbar = ((_e = config == null ? void 0 : config.toolbar) == null ? void 0 : _e.InlineButtons) && createAtomicPluginToolbar({
    buttons: {
      all: config.toolbar.InlineButtons,
      hidden: ((_f = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _f.hidden) || []
    },
    theme: __spreadValues(__spreadValues({}, toolbarTheme), config.theme),
    pubsub,
    helpers,
    innerModal: config.innerModal,
    settings,
    isMobile,
    anchorTarget,
    relValue,
    t,
    name: (_g = config == null ? void 0 : config.toolbar) == null ? void 0 : _g.name,
    uiSettings: config.uiSettings,
    getToolbarSettings: config.getToolbarSettings,
    getEditorBounds,
    getEditorState,
    linkTypes: (_h = config.LINK) == null ? void 0 : _h.linkTypes,
    innerRCERenderedIn
  });
  const externalizedButtonProps = insertButtons == null ? void 0 : insertButtons.map(
    (button) => generateInsertPluginButtonProps({
      blockType: config.type,
      button,
      helpers,
      pubsub,
      commonPubsub,
      settings,
      t,
      isMobile,
      pluginDefaults,
      getEditorState,
      setEditorState: (editorState) => {
        var _a2;
        (_a2 = commonPubsub.get("setEditorState")) == null ? void 0 : _a2(editorState);
      },
      toolbarName: TOOLBARS.INSERT_PLUGIN
    })
  );
  const InsertPluginButtons = settings.showInsertButtons && (insertButtons == null ? void 0 : insertButtons.map((button) => ({
    buttonSettings: button,
    component: createBaseInsertPluginButton({
      blockType: config.type,
      button,
      helpers,
      pubsub,
      commonPubsub,
      settings,
      t,
      theme,
      isMobile,
      pluginDefaults
    })
  }))) || [];
  const spoilerWrapper = config == null ? void 0 : config.spoilerWrapper;
  const PluginComponent = spoilerWrapper && config.component ? spoilerWrapper(config.component) : config.component;
  const BaseComponent = PluginComponent && createBaseComponent({
    PluginComponent,
    theme: config.theme,
    pluginDecorationProps: config.pluginDecorationProps,
    componentWillReceiveDecorationProps: config.componentWillReceiveDecorationProps,
    onOverlayClick,
    pubsub,
    commonPubsub,
    settings,
    helpers,
    t,
    anchorTarget,
    relValue,
    isMobile,
    getEditorBounds,
    disableRightClick,
    onComponentMount,
    locale,
    shouldRenderOptimizedImages,
    iframeSandboxDomain,
    setInPluginEditingMode,
    getInPluginEditingMode,
    renderInnerRCE,
    noPluginBorder,
    noPointerEventsOnFocus,
    withHorizontalScroll,
    disableKeyboardEvents,
    type: config.type
  });
  const DecoratedCompWithBase = BaseComponent && config.decorator ? config.decorator(BaseComponent) : BaseComponent;
  const InlineModals = config.inlineModals;
  const TextButtonMapper = config.toolbar && config.toolbar.TextButtonMapper;
  const blockRendererFn = (contentBlock, { getEditorState: getEditorState2, setEditorState }) => {
    var _a2;
    if (contentBlock.getType() === "atomic") {
      const contentState = getEditorState2().getCurrentContent();
      const key = contentBlock.getEntityAt(0);
      if (key) {
        const entity = contentState.getEntity(key);
        const entityType = entity.getType();
        let type;
        if (config.type === entityType || config.legacyType === entityType) {
          type = entityType;
        } else if (config.type === UNSUPPORTED_BLOCKS_TYPE && !((_a2 = config.supportedBlockTypes) == null ? void 0 : _a2.includes(entityType))) {
          type = UNSUPPORTED_BLOCKS_TYPE;
        }
        const blockRenderObject = type ? {
          component: DecoratedCompWithBase,
          editable: false,
          props: {
            getData: getData(
              contentBlock,
              { getEditorState: getEditorState2 },
              type === UNSUPPORTED_BLOCKS_TYPE
            ),
            setData: setData(contentBlock, { getEditorState: getEditorState2, setEditorState }, config.type),
            deleteBlock: deleteEntity(contentBlock, { getEditorState: getEditorState2, setEditorState }),
            type
          }
        } : null;
        return blockRenderObject;
      }
    }
    return null;
  };
  const commonProps = __spreadValues({
    InlinePluginToolbar,
    Toolbar,
    InsertPluginButtons,
    externalizedButtonProps,
    blockType: config.type,
    InlineModals,
    TextButtonMapper,
    pubsub,
    customStyleFn
  }, decoratorTrigger ? { decoratorTrigger } : {});
  return __spreadValues(__spreadProps(__spreadValues({}, commonProps), {
    blockRendererFn
  }), underlyingPlugin || {});
};

export { createBasePlugin };
//# sourceMappingURL=createBasePlugin.js.map
